import * as types from './constants'

export const googlePayInitReadyToPay = () => ({ type: types.GOOGLE_PAY_INIT_READY_TO_PAY })

export const googlePayReadyToPaySuccess = isReadyToPay => ({
    type: types.GOOGLE_PAY_READY_TO_PAY_SUCCESS,
    isReadyToPay,
})

export const googlePayReadyToPayFailure = error => ({ type: types.GOOGLE_PAY_READY_TO_PAY_FAILURE, error })
